import React from 'react';
import { Badge } from '@/components/ui/badge';
import { Clock } from 'lucide-react';
import { CollapsibleSection } from './IntelligenceUIComponents';

export const HistoricalTimelineSection = ({ data }) => {
  const { historicalTimeline } = data;
  
  const getImpactStyle = (impact) => {
    switch(impact) {
      case 'Peak':
      case 'Major Positive':
        return 'bg-stable border-stable';
      case 'Positive':
        return 'bg-primary border-primary';
      case 'Neutral':
        return 'bg-muted border-muted-foreground';
      default:
        return 'bg-background border-border';
    }
  };

  const getImpactBadgeStyle = (impact) => {
    switch(impact) {
      case 'Peak':
      case 'Major Positive':
        return 'bg-stable/20 text-stable';
      case 'Positive':
        return 'bg-primary/20 text-primary';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };
  
  return (
    <CollapsibleSection title="Historical Timeline" icon={Clock} defaultOpen={false} badge="Career Milestones">
      <div className="relative">
        <div className="absolute left-4 top-0 bottom-0 w-0.5 bg-border" />
        <div className="space-y-4">
          {historicalTimeline.map((event, i) => (
            <div key={i} className="relative pl-10">
              <div className={`absolute left-2 w-5 h-5 rounded-full border-2 ${getImpactStyle(event.impact)}`} />
              <div className="p-3 bg-muted/20 rounded-lg">
                <div className="flex items-center justify-between mb-1">
                  <span className="text-sm font-semibold">{event.event}</span>
                  <Badge variant="outline" className="text-xs">{event.year}</Badge>
                </div>
                <p className="text-xs text-muted-foreground">{event.description}</p>
                <Badge className={`mt-2 text-xs ${getImpactBadgeStyle(event.impact)}`}>{event.impact}</Badge>
              </div>
            </div>
          ))}
        </div>
      </div>
    </CollapsibleSection>
  );
};

export default HistoricalTimelineSection;
